module.exports = __webpack_public_path__ + "static/Smartphone-502c8a7dba98d7bad86e63611465d308.png";